import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSlide, UserTutorialStatusType } from "../../tutorial.models";

export const GETTING_STARTED: TutorialSlide[] = [
    {
        key: 'Getting-Started',
        // title: 'Learn How to use MedicAI',
        messages: [{ text: "Click on the video above to learn more about MedicAI!" }],
        videoUrl: 'https://www.youtube.com/watch?v=rtKmcBW6MNU',
        thumbnailUrl: 'assets/getting-started-thumbnail.png',
        tutorialStatusType: UserTutorialStatusType.INTRODUCTION,
        hideDoNotShowAgain: true,
        dimensions: { width: '450px' },
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.CLOSE_GETTING_STARTED
            },
        ],
        position: { x: 700, y: 350 },
    },
];
